import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxEzModalService } from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import { PromoSelectModalComponent } from '../promo-select/promo-select-modal.component';
import { DivisionsService } from "../../../../../../shared/modules/core/services/divisions.service";

@Component({
  selector: 'app-wild-rift-lp-select',
  templateUrl: './wild-rift-lp-select.component.html',
  styleUrls: ['./wild-rift-lp-select.component.scss']
})
export class WildRiftLpSelectComponent {
  @Input() set currentRank(val: number) {

    if (val < DivisionsService.getValueByRank('Bronze IV', 'wild-rift')) { // Iron
      this.lps = { '0': 0, '1': 1, '2': 2 };
    } else if (val < DivisionsService.getValueByRank('Gold IV', 'wild-rift')) { // Bronze, Silver
      this.lps = { '0': 0, '1': 1, '2': 2, '3': 3 };
    } else if (val < DivisionsService.getValueByRank('Emerald IV', 'wild-rift')) { // Gold, Platinum
      this.lps = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4 };
    } else if (val < DivisionsService.getValueByRank('Diamond IV', 'wild-rift')) { // Emerald
      this.lps = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5 };
    } else if (val < DivisionsService.getValueByRank('Master', 'wild-rift')) { // Diamond
      this.lps = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6 };
    } else if (val < DivisionsService.getValueByRank('Grandmaster', 'wild-rift')) {
      this.lps = { '0-4': 0, '5-9': 5, '10-14': 10, '15-19': 15, '20-24': 20, '25-29': 25 };
    } else if (val < DivisionsService.getValueByRank('Challenger', 'wild-rift')) {
      this.lps = { '30-34': 30, '35-39': 35, '40-44': 40, '45-49': 45, '50-54': 50, '55-59': 55 };
    }
  }
  @Input() lang: string;

  @Output() selected = new EventEmitter<string | number>();

  lps: Record<string, number>;
  title: string = 'select_current_marks';

  constructor(public modalService: NgxEzModalService) { }

  public onSelect(lp) {
    this.selected.emit(lp);
    this.modalService.closeOutletModals('public');
  }

  customSort = (a: { key: string; value: number }, b: { key: string; value: number }) => {
    const getNumericValue = (key: string) => parseInt(key.split('-')[0], 10);
    return getNumericValue(a.key) - getNumericValue(b.key);
  };
}